
import React from "react";
import { Check, X } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { TableRow, TableCell } from "@/components/ui/table";

interface MenuItemProps {
  id: string;
  title: string;
  path: string;
  section: string;
  can_access: boolean;
  onCheckboxChange: (id: string, checked: boolean) => void;
}

export const MenuItemComponent = ({
  id,
  title,
  path,
  section,
  can_access,
  onCheckboxChange
}: MenuItemProps) => {
  return (
    <TableRow>
      <TableCell>{title}</TableCell>
      <TableCell>{section}</TableCell>
      <TableCell><code className="text-xs">{path}</code></TableCell>
      <TableCell className="text-center">
        <div className="flex justify-center items-center">
          <Checkbox 
            checked={can_access}
            onCheckedChange={(checked) => 
              onCheckboxChange(id, !!checked)
            }
            className="mr-2"
          />
          {can_access ? 
            <Check className="h-4 w-4 text-green-500" /> : 
            <X className="h-4 w-4 text-red-500" />
          }
        </div>
      </TableCell>
    </TableRow>
  );
};
